/**
 * Reads a CSS custom property's live computed value — for SVG/canvas contexts
 * (React Flow nodes, MiniMap, edge styles) that can't resolve `var(--x)` the
 * way a className can. Cached per token+theme pair; the cache is cleared
 * whenever the `dark` class on <html> toggles (Tailwind's `darkMode: 'class'`
 * strategy), so live theme switching never leaves a stale color behind.
 */
const cache = new Map<string, string>();
let observing = false;

function currentThemeKey(): string {
  return document.documentElement.classList.contains('dark') ? 'dark' : 'light';
}

function ensureObserver(): void {
  if (observing || typeof MutationObserver === 'undefined') return;
  observing = true;
  new MutationObserver(() => cache.clear()).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
}

export function resolveToken(name: string, fallback: string): string {
  if (typeof document === 'undefined') return fallback;
  ensureObserver();
  const key = `${currentThemeKey()}:${name}`;
  const cached = cache.get(key);
  if (cached !== undefined) return cached;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim() || fallback;
  cache.set(key, value);
  return value;
}
